export default __webpack_public_path__ + "static/media/placeholder-1200.5b1db07c.png";